<template>
  <div class="con">
    <div class="content">
      <div class="btn-com">
        <div class="com-left">
          <div>
            <h6>全国统一服务热线</h6>
            <h2>400-1868-666</h2>
          </div>
          <div class="com-left-top">
            <h6>公司座机</h6>
            <h2 style="font-size: 16px;">0596-7216157 7216156</h2>
          </div>
          <div class="com-left-top">
            <h6>地址</h6>
            <h6>厦门市同安工业集中区集和路190号</h6>
          </div>
        </div>
        <div class="bottom-two">
          <div class="bottom-nav">
            <ul>
              <li>
                <router-link to="/Setmeal">精选整装</router-link>
                <br />
                <div class="textsize">
                  <router-link to="/Lifecycle">六大生命周期</router-link>
                </div>
                <div class="textsize">
                  <router-link to="/Setmeal">套餐介绍</router-link>
                </div>
                <div class="textsize">
                  <router-link to="/Product">产品介绍</router-link>
                </div>
              </li>
              <li>
                <router-link to="/Designer">精选设计</router-link>
                <br />
                <div class="textsize">
                  <router-link to="/Designer">优秀设计师</router-link>
                </div>
                <div class="textsize">
                  <router-link to="/Sketch">效果图赏析</router-link>
                </div>
                <div class="textsize">
                  <router-link to="/Panorama">全景图赏析</router-link>
                </div>
              </li>
              <li>
                <router-link to="/DecorationCase">精选装修</router-link>
                <br />
                <div class="textsize">
                  <router-link to="/DecorationCase">装修案例</router-link>
                </div>
                <div class="textsize">
                  <router-link to="/DecorationProcess">施工工艺</router-link>
                </div>
                <div class="textsize">
                  <router-link to="/Onlinesite">在线工地</router-link>
                </div>
              </li>
              <li>
                <router-link to="/NewJoin">商务合作</router-link>
                <br />
                <div class="textsize">
                  <router-link to="/NewJoin">我要加盟</router-link>
                </div>
                <div class="textsize">
                  <router-link to="/NewManufacturer">我是厂家</router-link>
                </div>
              </li>
              <li>
                <div class="textsize">
                  <router-link to="/Renovationloan">装修指南</router-link>
                </div>
                <div class="textsize">
                  <router-link to="/Renovationloan">装修贷款</router-link>
                </div>
                <div class="textsize">
                  <router-link to="/DecoMethod">装修宝典</router-link>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="bottom-one2">
          <div class="vxleft">
            扫码关注微信公众号
            <br />
            <img
              style="width:100px;height:100px; margin-top:20px;"
              src="../assets/images/WechatIMG14.jpeg"
            />
            <br />精选整装 好而不贵
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-text">
      <a href="http://beian.miit.gov.cn" target="view_window">
        <div class="copyright">© 厦门金牌桔家云整装科技有限公司 版权所有,并保留所有权利闽ICP备19008840号-1</div>
      </a>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  data() {
    return {
      activeIndex: "1",
      activeIndex2: "1",
    };
  },
  methods: {},
};
</script>
<style scoped>
a {
  text-decoration: none;
  color: #fff;
}
.com-left {
  width: 276px;
  height: 223px;
  color: #fff;
  border-right: 1px solid #565454;
}
.com-left-top {
  margin-top: 50px;
}
h6 {
  margin-block-start: 0em;
  margin-block-end: 0em;
}
h2 {
  margin-block-start: 0em;
  margin-block-end: 0em;
}
.content {
  width: 100%;
  height: 370px;
  background: #383838;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-com {
  width: 1280px;
  display: flex;
  overflow: hidden;
}
.bottom-one {
  color: #fff;
}
.bottom-one2 {
  color: #fff;
}
.boottom-one img {
}
.bottom-two {
  width: 688px;
  color: #fff;
}
.bottom-nav {
  width: 582px;
  height: 223px;
  overflow: hidden;
  margin: 0 auto;
  border-right: 1px solid #565454;
}
.bottom-nav ul {
  padding: 0;
  margin-left: -64px;
}
.bottom-nav ul li {
  list-style: none;
  float: left;
  margin-left: 64px;
  text-align: left;
  padding-left: 10px;
}
.phone {
  text-align: center;
  font-size: 14px;
}
.copyright {
  text-align: center;
  font-size: 12px;
  margin-bottom: 5px;
}
.textsize {
  font-size: 13px;
  margin-top: 1rem;
}
.textsize:hover {
  text-decoration: underline;
}
.vxleft {
  font-size: 16px;
}
p {
  margin-block-start: 0em;
  margin-block-end: 0em;
}
.bottom-text {
  height: 50px;
  line-height: 50px;
  color: #fff;
  background: #383838;
}
</style>
